import * as React from "react";
import { DragDropContext, DropResult } from "react-beautiful-dnd";
import { CoughEventTypeDroppable, CorrectedArrayFieldProps } from "./CoughEventType";
import { useArrayField } from "informedv4";
import { v4 } from "uuid";

interface CoughSettingsEventsProps {
}

export const CoughSettingsEvents = ({  }: CoughSettingsEventsProps) => {
    const { arrayFieldState, arrayFieldApi } = useArrayField({ name: "eventTypes" } as any);

    const onDragEndInDelete = (result: DropResult) => {

        const sourceIndex = result.source.index;

        arrayFieldApi.remove(sourceIndex);
    };

    const onDragEnd = (result: DropResult) => {
        if (!result.destination) {
            return;
        }

        const sourceIndex = result.source.index;
        const destIndex = result.destination.index;

        if (result.destination.droppableId === "Delete") {
            return onDragEndInDelete(result);
        }


        arrayFieldApi.swap(sourceIndex, destIndex);
    };

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <h2 className="text-primary">Events</h2>
                </div>
                <div className="col-md-6 h2">
                    <button className="btn btn-primary btn-outline pull-right" onClick={() => arrayFieldApi.addWithInitialValue({ id: v4(), name: "temp", color: "#000000" })}>Add Event Type</button>
                </div>
            </div>
            <div className="panel panel-default">
                <div className="panel-body">
                    <div className="row">
                        <div className="pull-right col-md-12">
                            <DragDropContext onDragEnd={onDragEnd}>
                                <div className="row">
                                    <CoughEventTypeDroppable eventTypes={arrayFieldState.fields as CorrectedArrayFieldProps[] } />
                                </div>
                            </DragDropContext>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
